// src/features/counter/counterSlice.js
import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";
export const sendToAuditInfo = createAsyncThunk(
  "episodeStatus/sendToAuditInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        // "https://gub0w2lijl.execute-api.ap-southeast-2.amazonaws.com/dummy/send_to_audit_info",
        "/send_to_audit_info",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching send to audit info:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch data"
      );
    }
  }
);

export const getCdqTemplate = createAsyncThunk(
  "episodeStatus/getCdqTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/get_all_cdq_templates",
        
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching send to audit info:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch data"
      );
    }
  }
);

export const getClinicianData = createAsyncThunk(
  "episodeStatus/getClinicianData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/get_clinician_search",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching clinician data:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch clinician data"
      );
    }
  }
);

    


export const getCdqTemplateDetails = createAsyncThunk(
  "episodeStatus/getCdqTemplateDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/get_cdq_template_details",
        payload
      );

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching CDQ template details:",
        error
      );

      return rejectWithValue(
        error.response?.data || "Failed to fetch template details"
      );
    }
  }
);

export const getHistoricalPatientInfo = createAsyncThunk(
  "episodeStatus/getHistoricalPatientInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/get_historical_patient_info",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching send to audit info:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch data"
      );
    }
  }
);


const EpisodeStatusSlice = createSlice({
  name: "episodeSatus",
  initialState: {
   drgSelectedVersion: "",
    selectedDrgData: null,
     auditors: [],
    queues: [],

    hasMore: false,
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,

    queuesloading: false,
    error: null,
    clickedEpisodeQueues:[],
      // ✅ NEW
    historicalPatientInfo: [],
    historicalPatientInfoLoading: false,
    historicalPatientInfoHasMore: false,
    historicalPatientInfoError: null,
    historicalPatientInfoPage: 1,
    historicalRecordsCount:null,
    historicalPatientInfoMessage: null, 
    isNudgeCardOpen: false,
    nudgesCount:2,


  cdqTemplates: [],
  cdqTemplatesLoading: false,
  cdqTemplatesError: null,
  cdqTemplatesTotalCount: 0,
  cdqTemplatesPageNumber: 1,
  cdqTemplatesPageSize: 4,

  // NEW
  cdqTemplateDetails: null,
  cdqTemplateDetailsLoading: false,
  cdqTemplateDetailsError: null,
    // ✅ Clinician Search
  clinicians: [],
  cliniciansLoading: false,
  cliniciansError: null,
  cliniciansTotalCount: 0,
  cliniciansPageNumber: 1,
  cliniciansPageSize: 5,
  cliniciansHasMore: false,

  cdqRequest: {
  template_name: "",
  clinician_to_sent_info: {
  responding_clinician: "",
    email: "",
    specialty: "",
  },
  cdq_category: [],
  query: "",
  response_options: [],
},
  },
  reducers: {
   storeDrgVersionAndData:(state,action) =>{
     state.drgSelectedVersion = action.payload.selectedVersion;
      state.selectedDrgData = action.payload.selectedDrgData;
   },
  setClickedEpisodeQueues:(state,action) =>{
    state.clickedEpisodeQueues = action.payload
  },
  setHistoricalPatientInfoPage: (state, action) => {
      state.historicalPatientInfoPage = action.payload;
    },
    setCdqTemplatesPage: (state, action) => {
  state.cdqTemplatesPageNumber = action.payload;
},
setCdqRequest: (state, action) => {
  state.cdqRequest = action.payload;
},

resetCdqRequest: (state) => {
  state.cdqRequest = {
    template_name: "",
    clinician_to_sent_info: {
      responding_clinician: "",
      email: "",
      specialty: "",
    },
    cdq_category: [],
    query: "",
    response_options: [],
  };
},
  resetHistoricalPatientInfo: (state) => {
      state.historicalPatientInfo = [];
  state.historicalPatientInfoHasMore = false;
  state.historicalPatientInfoError = null;
  state.historicalPatientInfoPage = 1;      // ✅ NEW
  state.historicalRecordsCount = null;  
  state.historicalPatientInfoMessage = null;  
    },
     
  // NEW — dispatched by the Nudges button onClick
  openNudgeCard: (state) => {
    state.isNudgeCardOpen = true;
  },
  closeNudgeCard: (state) => {
    state.isNudgeCardOpen = false;
  },
   setNudgesCount: (state, action) => {
    state.nudgesCount = action.payload;
  },
  },
   extraReducers: (builder) => {
    builder
      // ✅ PENDING
      .addCase(sendToAuditInfo.pending, (state) => {
        state.queuesloading = true;
        state.error = null;
      })

      // ✅ SUCCESS
      .addCase(sendToAuditInfo.fulfilled, (state, action) => {
        state.queuesloading = false;

        state.auditors = action.payload.auditors || [];
        state.queues = action.payload.queues || [];

        state.hasMore = action.payload.has_more;
        state.totalCount = action.payload.total_count;
        state.pageNumber = action.payload.page_number;
        state.pageSize = action.payload.page_size;
      })

      // ✅ FAILED
      .addCase(sendToAuditInfo.rejected, (state, action) => {
        state.queuesloading = false;
        state.error = action.payload;
      })

      //  NEW
      .addCase(getHistoricalPatientInfo.pending, (state) => {
        state.historicalPatientInfoLoading = true;
        state.historicalPatientInfoError = null;
      })

      .addCase(getHistoricalPatientInfo.fulfilled, (state, action) => {
        state.historicalPatientInfoLoading = false;
        state.historicalPatientInfoError = null;
        state.historicalPatientInfo = action.payload.data || [];
        state.historicalRecordsCount = action.payload.total_count ?? null;
        state.historicalPatientInfoPage = action.meta.arg?.page_number ?? 1;
        state.historicalPatientInfoHasMore = action.payload.has_more ?? false;
        state.historicalPatientInfoMessage = action.payload.message ?? null;
      })
      .addCase(getHistoricalPatientInfo.rejected, (state, action) => {
        state.historicalPatientInfoLoading = false;
        state.historicalPatientInfoError = action.payload;
      })

      .addCase(getCdqTemplate.pending, (state) => {
  state.cdqTemplatesLoading = true;
  state.cdqTemplatesError = null;
})

.addCase(getCdqTemplate.fulfilled, (state, action) => {
  state.cdqTemplatesLoading = false;
  state.cdqTemplatesError = null;

  state.cdqTemplates =
    action.payload?.data?.templates || [];

  state.cdqTemplatesTotalCount =
    action.payload?.total_count ?? 0;

  state.cdqTemplatesPageNumber =
    action.payload?.page_number ?? 1;

  state.cdqTemplatesPageSize =
    action.payload?.page_size ?? 10;
})

.addCase(getCdqTemplate.rejected, (state, action) => {
  state.cdqTemplatesLoading = false;
  state.cdqTemplatesError = action.payload;
})
.addCase(getCdqTemplateDetails.pending, (state) => {
  state.cdqTemplateDetailsLoading = true;
  state.cdqTemplateDetailsError = null;
})

.addCase(getCdqTemplateDetails.fulfilled, (state, action) => {
  state.cdqTemplateDetailsLoading = false;
  state.cdqTemplateDetailsError = null;

  state.cdqTemplateDetails =
    action.payload?.data || null;
})

.addCase(getCdqTemplateDetails.rejected, (state, action) => {
  state.cdqTemplateDetailsLoading = false;
  state.cdqTemplateDetailsError = action.payload;
})

.addCase(getClinicianData.pending, (state) => {
  state.cliniciansLoading = true;
  state.cliniciansError = null;
})

.addCase(getClinicianData.fulfilled, (state, action) => {
  state.cliniciansLoading = false;
  state.cliniciansError = null;

  const newClinicians =
    action.payload?.data?.clinicians || [];

  const pageNumber =
    action.meta.arg?.page_number ?? 1;

  // First page = replace
  if (pageNumber === 1) {
    state.clinicians = newClinicians;
  } else {
    // Next pages = append
    state.clinicians = [
      ...state.clinicians,
      ...newClinicians,
    ];
  }

  state.cliniciansTotalCount =
    action.payload?.total_count ?? 0;

  state.cliniciansPageNumber =
    pageNumber;

  state.cliniciansPageSize =
    action.meta.arg?.page_size ?? 5;

  state.cliniciansHasMore =
    action.payload?.has_more ?? false;
})

.addCase(getClinicianData.rejected, (state, action) => {
  state.cliniciansLoading = false;
  state.cliniciansError = action.payload;
})

  }

  
 
});

export const {storeDrgVersionAndData,setClickedEpisodeQueues,  resetHistoricalPatientInfo,  setHistoricalPatientInfoPage, setCdqTemplatesPage, setCdqRequest,resetCdqRequest} = EpisodeStatusSlice.actions;
export default EpisodeStatusSlice.reducer;
